import apiClient from "./axios";

// 汇率管理相关API
export const exchangeRateApi = {
    // 获取汇率列表
    getExchangeRateList: async (params = {}) => {
        return await apiClient.get("/v1/exchange-rates", { params });
    },

    // 获取单个汇率详情
    getExchangeRate: async (id) => {
        return await apiClient.get(`/v1/exchange-rates/${id}`);
    },

    // 创建新汇率
    createExchangeRate: async (data) => {
        // 直接返回apiClient的调用结果，让上层统一处理错误
        return await apiClient.post("/v1/exchange-rates", data);
    },

    // 更新汇率
    updateExchangeRate: async ({ id, data }) => {
        return await apiClient.put(`/v1/exchange-rates/${id}`, data);
    },

    // 删除汇率
    deleteExchangeRate: async (id) => {
        return await apiClient.delete(`/v1/exchange-rates/${id}`);
    },

    // 批量删除汇率
    batchDeleteExchangeRates: async (data) => {
        return await apiClient.post("/v1/exchange-rates/batch-delete", data);
    },

    // 获取支持的货币列表
    getCurrencies: async () => {
        return await apiClient.get("/v1/exchange-rates/currencies");
    },

    // 获取指定货币对的当前汇率
    getCurrentExchangeRate: async (fromCurrency, toCurrency, targetDate = null) => {
            const params = targetDate ? { target_date: targetDate } : {};
        return await apiClient.get(
            `/v1/exchange-rates/current/${fromCurrency}/${toCurrency}`, 
                { params }
            );
    },
};

export default exchangeRateApi;
